import { render, staticRenderFns } from "./DiffCheckSwitch.vue?vue&type=template&id=60f1c788&"
import script from "./DiffCheckSwitch.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DiffCheckSwitch.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports